import { cardAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineSlotRecipe({
  slots: cardAnatomy.keys(),
  base: {
    root: {
      ...interactiveTransition,
    },
  },
  variants: {
    variant: {
      elevated: {},
      voiceNoteRecorder: {
        root: {
          width: "100%",
          height: "100%",
          maxHeight: "100%",
          minHeight: "0",
          flex: "1 1 auto",
          overflow: "hidden",
          minWidth: "0",
          borderWidth: "0",
          boxShadow: "none",
          bg: "bg.panel",
        },
        body: {
          padding: "2",
          gap: "2",
          minHeight: "0",
          overflowY: "auto",
          minWidth: "0",
          "& audio": { width: "100%", maxWidth: "100%", flexShrink: "0" },
          "& svg[role=img]": {
            width: "100%",
            height: "8",
            flexShrink: "0",
            color: "fg.muted",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            fill: "none",
          },
        },
        footer: {
          flexShrink: "0",
          padding: "2",
          paddingTop: "0",
          gap: "2",
          justifyContent: "space-between",
          flexWrap: "wrap",
        },
      },
      messageReply: {
        root: {
          alignSelf: "stretch",
          minWidth: "0",
          maxWidth: "100%",
          margin: "2",
          borderWidth: "0",
          borderInlineStartWidth: "3px",
          borderInlineStartColor: "colorPalette.solid",
          borderRadius: "md",
          bg: "colorPalette.muted",
          color: "fg",
          boxShadow: "none",
          "&[role=button]": {
            cursor: "pointer",
            textAlign: "start",
            _hover: { bg: "colorPalette.subtle" },
            focusVisibleRing: "outside",
            focusRingColor: "colorPalette.focusRing",
          },
          "&[data-outgoing=true]": {
            borderInlineStartColor: "colorPalette.emphasized",
          },
          "& img": {
            width: "10",
            height: "10",
            objectFit: "cover",
            borderRadius: "sm",
            float: "right",
            marginInlineStart: "2",
          },
        },
        body: { padding: "2", gap: "1", minWidth: "0" },
        title: {
          fontSize: "xs",
          fontWeight: "semibold",
          color: "colorPalette.fg",
        },
        description: {
          fontSize: "sm",
          color: "colorPalette.fg",
          lineClamp: "2",
          overflowWrap: "anywhere",
          whiteSpace: "pre-wrap",
        },
        footer: {
          paddingInline: "2",
          paddingBottom: "1",
          justifyContent: "flex-end",
        },
      },
      // A selectable option tile in the Export Conversation modal.
      exportOption: {
        root: {
          width: "100%",
          cursor: "pointer",
          padding: "4",
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "border.muted",
          _hover: { bg: "bg.subtle", borderColor: "colorPalette.solid" },
          focusVisibleRing: "outside",
          focusRingColor: "colorPalette.focusRing",
        },
        body: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "2",
          "& svg": { boxSize: "8", color: "colorPalette.fg" },
        },
        description: { color: "fg.subtle", textAlign: "center" },
      },
      structuredMessage: {
        root: {
          mx: "auto",
          width: { base: "xs", md: "md", lg: "lg" },
          overflow: "hidden",
          bg: "colorPalette.subtle",
        },
      },
    },
  },
  defaultVariants: {
    variant: "elevated",
  },
});
